import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

const initialState = {};

export const subscriptionSlice = createSlice({
	name: "subscription",
	initialState,
	reducers: {},
	// extraReducers: (builder) => {},
});

export const subscriptionReducer = subscriptionSlice.reducer;
export const subscriptionSelector = (state: RootState) => state[subscriptionSlice.name];
